/**
 * Utilitários para sons de notificação
 */

// Cria um áudio de notificação simples usando Web Audio API
export const createNotificationSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    // Conecta os nós
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // Configura o som (notificação típica de chat)
    oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
    oscillator.frequency.setValueAtTime(600, audioContext.currentTime + 0.1);
    oscillator.frequency.setValueAtTime(1000, audioContext.currentTime + 0.2);
    
    // Configura o volume (mais suave)
    gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.25);
    
    // Toca o som
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.25);
    
    return true;
  } catch (error) {
    console.warn('Não foi possível tocar o som de notificação:', error);
    return false;
  }
};

// Função para tocar som de notificação com fallback
export const playNotificationSound = () => {
  // Tenta criar um som personalizado primeiro
  if (createNotificationSound()) {
    return;
  }
  
  // Fallback: tenta tocar um som usando HTML5 Audio
  try {
    const audio = new Audio();
    
    // Cria um som simples usando data URL (beep curto)
    const beepData = 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIG2m98OScTgwOUarm7blmGgU7k9n1unEiBC13yO/eizEIHWq+8+OWT';
    
    audio.src = beepData;
    audio.volume = 0.2;
    audio.play().catch(() => {
      // Se falhar, tenta um beep mais simples
      console.log('\u0007'); // Beep do terminal (funciona em alguns navegadores)
    });
  } catch (error) {
    console.warn('Não foi possível tocar nenhum som de notificação:', error);
  }
};

// Função para verificar se o navegador suporta áudio
export const isAudioSupported = () => {
  return !!(window.AudioContext || window.webkitAudioContext || window.Audio);
};

// Função para configurar permissões de áudio (para navegadores que precisam)
export const requestAudioPermission = async () => {
  try {
    if (window.AudioContext || window.webkitAudioContext) {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // Para alguns navegadores, é necessário "resumir" o contexto
      if (audioContext.state === 'suspended') {
        await audioContext.resume();
      }
      
      return true;
    }
    return false;
  } catch (error) {
    console.warn('Erro ao configurar permissões de áudio:', error);
    return false;
  }
};

// Função para testar o som (útil para debug)
export const testNotificationSound = () => {
  playNotificationSound();
};
